(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diy-lash-lp"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dlp').forEach((root) => {
    root.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => {
      const main = root.querySelector('[data-main-media] img');
      if (main) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = button.dataset.src;
        main.alt = button.dataset.alt || '';
      }
      root.querySelectorAll('.dlp__thumb').forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); });
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
    }));
    const coupon = root.querySelector('[data-copy-coupon]');
    if (coupon) coupon.addEventListener('click', async () => { await navigator.clipboard.writeText('YOYAKU15'); coupon.textContent = 'コピーしました！'; setTimeout(() => coupon.textContent = 'コピーする', 1800); });
    const property = root.querySelector('[data-bundle-property]');
    const stickyPlan = root.querySelector('[data-sticky-plan]');
    const addButton = root.querySelector('.dlp__form .dlp__atc');
    const variantsNode = root.querySelector('[data-variants-json]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const labels = {'1箱':'1箱 ¥7,767','2箱セット':'2箱セット ¥13,980','3箱セット':'3箱セット ¥18,980'};
    const updateVariant = () => {
      const bundle = root.querySelector('input[name="bundle_choice"]:checked')?.value;
      const ship = root.querySelector('input[name="ship_choice"]:checked')?.value; const match = variants.find((variant) => variant.options.includes(bundle) && variant.options.includes(ship));
      const variantId = root.querySelector('[data-variant-id]');
      if (property) property.value = bundle;
      if (stickyPlan) stickyPlan.textContent = `${labels[bundle]}（11月中旬予約）`;
      if (match && variantId) variantId.value = match.id;
      if (addButton) {
        addButton.disabled = !match || !match.available;
        addButton.textContent = !match ? '発送時期を設定してください' : (match.available ? '予約して理想の目元を手に入れる' : '在庫切れ');
      }
    };
    root.querySelectorAll('input[name="bundle_choice"]').forEach((radio) => radio.addEventListener('change', updateVariant));
    updateVariant();
    root.querySelectorAll('[data-open]').forEach((button) => button.addEventListener('click', () => root.querySelector(`[data-dialog="${button.dataset.open}"]`).showModal()));
    root.querySelectorAll('.dlp__dialog').forEach((dialog) => { dialog.querySelector('.dlp__close').addEventListener('click', () => dialog.close()); dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }); });
    root.querySelectorAll('[data-before-after] input').forEach((range) => range.addEventListener('input', () => range.parentElement.style.setProperty('--position', `${range.value}%`)));
    const lightbox = root.querySelector('.dlp__lightbox');
    root.querySelectorAll('[data-lightbox]:not([disabled])').forEach((button) => button.addEventListener('click', () => { const image = button.querySelector('img'); if (image) { lightbox.querySelector('img').src = image.currentSrc || image.src; lightbox.hidden = false; } }));
    if (lightbox) { lightbox.querySelector('button').addEventListener('click', () => lightbox.hidden = true); lightbox.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.hidden = true; }); }
    const stickySubmit = root.querySelector('[data-sticky-submit]');
    if (stickySubmit) stickySubmit.addEventListener('click', () => root.querySelector('.dlp__form').requestSubmit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    document.querySelectorAll('.gl-header').forEach(header=>{const button=header.querySelector('.gl-header__menu-button');const menu=header.querySelector('.gl-header__nav');if(button&&menu)button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));menu.classList.toggle('is-open',!open)})});
  } catch(e) { console.error(e); }
})();
})();
